import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Dialog","DialogTrigger","DialogContent","DialogHeader","DialogTitle","DialogDescription"] */ "/app/components/ui/dialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Label"] */ "/app/components/ui/label.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
